import React from 'react';
import { Group, Radio } from '@mantine/core';
import PropTypes from 'prop-types';

export default function RadioList({ inputProps, items, input }){

  const onChange = (e) => {
    input.onChange(e);
  };

  return(
    <Radio.Group
      label={inputProps.label}
      onChange={onChange}
      size="md"
      value={inputProps.defaultValue}
      withAsterisk
    >

      <Group mt="xs">
        {
          items.map((data) =>
            <Radio fz={10} key={data.value} label={data.label} value={data.value}/>
          )
        }
      </Group>
    </Radio.Group>
  );
}

RadioList.propTypes = {
  input: PropTypes.object,
  inputProps: PropTypes.object,
  items: [{
    label: PropTypes.string,
    value: PropTypes.string
  }],
};
